import React, {useContext} from 'react';
import { Routes, Route } from 'react-router-dom';

import EquipsRegistryTabPanel from './equipsPanel/EquipsRegistryTabPanel';
import EquipsTabPanel from './equipsPanel/EquipsTabPanel';
import EquipsServiceTabPanel from './equipsPanel/EquipsServiceTabPanel';

export default function EquipsTab(props) {
  console.log("render EquipsTab");

  return (
    <div name="divEquipsTab">
      <Routes>
        <Route path="/main" element={<EquipsTabPanel/>}/>
        <Route path="/registry" element={<EquipsRegistryTabPanel/>} />
        <Route path="/service" element={<EquipsServiceTabPanel/>} />
      </Routes>
    </div>
  );
}